<template>
    <span :class="extClasses"></span>
</template>
<script>
import { getFileType } from '@/utils/mime'
export default {
  name: 'FileEntityIcon',
  props: {
    filename: {
      type: String,
      requred: true
    }
  },
  computed: {
    extClasses() {
      return `file-entity-icon ext-${getFileType(this.filename)}`
    }
  }
}
</script>
<style lang="less" scoped>
.file-entity-icon {
    display: inline-block;

    background-position: left center;
    background-size: cover;
    background-repeat: no-repeat;

    &.ext-word {
        background-image: url(~@/assets/icon-word.svg);
    }

    &.ext-excel {
        background-image: url(~@/assets/icon-excel.svg);
    }

    &.ext-ppt {
        background-image: url(~@/assets/icon-ppt.svg);
    }

    &.ext-pdf {
        background-image: url(~@/assets/icon-pdf.svg);
    }

    &.ext-video {
        background-image: url(~@/assets/icon-video.svg);
    }

    &.ext-audio {
        background-image: url(~@/assets/icon-music.svg);
    }

    &.ext-image {
        background-image: url(~@/assets/icon-image.svg);
    }

    &.ext-bin {
        background-image: url(~@/assets/icon-bin.svg);
    }
}
</style>
